<template>
    <div class="section grey-card">
        <v-container class="px-10">
            <v-row cols="12" justify="center">
                <v-col cols="7" class="px-10 text-center">
                    <h1>Workflow Wizard</h1>
                    <h2 class="text-h5 font-italic mb-5">Turn Any Automation Into a Polished App</h2>
                    <p> 
                        Your workflows shouldn’t live behind code. Workflow Wizard lets you easily transform any automation into a clean, shareable <b>web interface</b> — ready to use in minutes, no coding required.
                    </p>
                    <div class="d-flex justify-center"><hr/></div>
                    
                    <h2 class="text-h6 font-weight-bold mb-5">Instant, Polished Experiences</h2>
                        From two-factor authentication to customer-facing tools, Workflow Wizard gives your team and clients a seamless, professional experience. Build once, share instantly, and let your automations shine.
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
    name: 'WorkflowsWizard',
}
</script>

<style lang="scss">


hr {
    margin: 1em 0;
    width: 50%;
}
</style>